




















































































import { Trajet } from "../../models/Trajet";
import { DistanceApi } from "../../api/DistanceApi";

export default {
    name: "DistanceLine",
    props: {
        distance: Object,
    },
    data() {
        return {
            displayedDistance: null,
            editingDistance: null,
            loading: false,
            EStatus: Trajet.Distance.EStatus,
            editing: false,
            DistanceApi: new DistanceApi(),
        };
    },
    created() {
        this.displayedDistance = new Trajet.Distance(this.distance);
    },
    methods: {
        openInGoogleMaps: function () {
            let origin =
                this.displayedDistance.origin.adresse.adresse +
                ", " +
                this.displayedDistance.origin.adresse.code_postal +
                ", " +
                this.displayedDistance.origin.adresse.ville +
                " " +
                this.displayedDistance.origin.adresse.pays;
            let destination =
                this.displayedDistance.destination.adresse.adresse +
                ", " +
                this.displayedDistance.destination.adresse.code_postal +
                ", " +
                this.displayedDistance.destination.adresse.ville +
                " " +
                this.displayedDistance.destination.adresse.pays;
            origin = origin.replace(/\n/g, " ");
            destination = destination.replace(/\n/g, " ");
            let maps_url =
                "https://www.google.com/maps/dir/?api=1&travelmode=bicycling&origin=" +
                origin +
                "&destination=" +
                destination;
            let win = window.open(maps_url, "_blank");
            win.focus();
        },
        recomputeDistance() {
            let self = this;
            this.loading = true;
            this.DistanceApi.refreshDistance(this.displayedDistance.id).then(
                function (distance) {
                    self.displayedDistance = distance;
                    self.loading = false;
                }
            );
        },
        isStatus(status: Trajet.Distance.EStatus): boolean {
            return this.displayedDistance.status == status;
        },
        edit() {
            this.editingDistance = new Trajet.Distance(this.displayedDistance);
            this.editingDistance.status = Trajet.Distance.EStatus.Manual;
            this.editing = true;
        },
        validate() {
            this.editingDistance = new Trajet.Distance(this.displayedDistance);
            this.editingDistance.status = Trajet.Distance.EStatus.Validated;
            this.save();
        },
        save() {
            let self = this;
            self.DistanceApi.save(self.editingDistance).then(function (
                distance
            ) {
                self.displayedDistance = distance;
                self.editing = false;
                self.$emit("distance-updated", distance);
            });
        },
        cancelEdit() {
            this.editing = false;
        },
    },
};
